"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_1 = require("@21st-night/ui");
var DeckAddCardButton = function (_a) {
    var onClick = _a.onClick, onClickCreateFromImage = _a.onClickCreateFromImage, onClickImportFromCsv = _a.onClickImportFromCsv, onClickImportFromQuizlet = _a.onClickImportFromQuizlet, onClickImportFromDeck = _a.onClickImportFromDeck;
    var _b = __read(react_1.useState(false), 2), menuOpen = _b[0], setMenuOpen = _b[1];
    function openMenu() {
        setMenuOpen(true);
    }
    function closeMenu() {
        setMenuOpen(false);
    }
    return (react_1.default.createElement(ui_1.SplitButton, { style: { whiteSpace: 'nowrap' }, onClick: onClick, menuOpen: menuOpen, onOpenMenu: openMenu, onCloseMenu: closeMenu, label: "Add Cards" },
        react_1.default.createElement(ui_1.MenuItem, { onClick: function () {
                closeMenu();
                onClickCreateFromImage();
            } }, "Create cards from an image"),
        react_1.default.createElement(ui_1.MenuItem, { onClick: function () {
                closeMenu();
                onClickImportFromCsv();
            } }, "Import cards from a CSV file"),
        react_1.default.createElement(ui_1.MenuItem, { onClick: function () {
                closeMenu();
                onClickImportFromQuizlet();
            } }, "Import cards from Quizlet"),
        react_1.default.createElement(ui_1.MenuItem, { onClick: function () {
                closeMenu();
                onClickImportFromDeck();
            } }, "Import cards from another deck")));
};
exports.default = DeckAddCardButton;
//# sourceMappingURL=DeckAddCardButton.js.map